<template>
	<a class="skip-main" href="#main" target="_self">Hoppa till innehåll</a>
	<Header :settings="props.settings"/>
	<main id="main" tabindex="-1">
	  <router-view :settings="props.settings"/>
	</main>
	<Footer />
</template>

<script lang="ts">
import { PropType, defineComponent, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { useUserStore } from './stores/user';
import { useOrganisationStore } from './stores/organisation';
import { storeToRefs } from 'pinia';
import { StartViewModel } from '@Shared/Models/StartViewModel';

export default defineComponent({
	name: 'App',
	props: {
		settings: Object as PropType<StartViewModel>
	},
	components: {
		Header,
		Footer,
	},
	setup(props) {
		const router = useRouter();
		router.push(window.location.pathname.replace(router.options.history.base, ""));
		const userStore = useUserStore()
		const organisationStore = useOrganisationStore()
		const { organisations } = storeToRefs(organisationStore)

		if (!userStore.isAuthenticated){
      		const route = useRoute();
			userStore.Get().then(r => {}).catch(e => {
				if(!(route.path === '/' || route.path === '/login')) {
				router.push("/");
				}
      		})
		}
		watch(() => userStore.isAuthenticated, () => {
			if (userStore.isAuthenticated && !organisations.value.length){
				organisationStore.GetOrganisations()
			}
		})

		return {
			props
		};
	}
});
</script>